export const VISUAL_COMPONENT_BACKGROUNDS = {
  default: "bg-p300",
  scalest: "bg-scalest-background/[0.18]",
  scalar: "bg-scalar-background/[0.18]",
}

export const VISUAL_COMPONENT_HIGHLIGHTED_BACKGROUNDS = {
  default: "bg-p300",
  scalest: "bg-scalest-background/[0.36]",
  scalar: "bg-scalar-background/[0.36]",
}

export const VISUAL_COMPONENT_BORDERS = {
  default: "",
  scalest: "border-scalest-border/[.48]",
  scalar: "border-scalar-border/[0.48]",
}

export const VISUAL_COMPONENT_TEXT = {
  default: "text-t300",
  scalest: "text-scalest-text/[1]",
  scalar: "text-scalar-text/[1]",
}

export const NFT_BREADCRUMB_WIDGET_COLORS = {
  scalar: {
    wrapper: "border-scalar-border/[0.48] border bg-scalar-background/[0.12]",
    percentage: "border-scalar-border/[0.48] bg-scalar-background/[0.24]",
    text: "text-scalar-text",
  },
  scalest: {
    wrapper: "border-scalest-border/[0.48] border bg-scalest-background/[0.12]",
    percentage: "border-scalest-border/[0.48] bg-scalest-background/[0.24] ",
    text: "text-scalest-text",
  },
}
